import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './creator-tile-results-count.scss';

import type { CreatorTileType } from 'types';

applyTranslations(require('./creator-tile-results-count.i18n.json'));


type Props = {
  totalItems: number,
  type: CreatorTileType
};

const msgKey = 'creator_tile_results_count';

class CreatorTileResultsCount extends React.PureComponent<Props> {
  getResults = (): React.ReactNode | undefined | null => {
    const { totalItems, type } = this.props;
    let countLabel = '';

    if (!totalItems) {
      return null;
    }

    if (type === 'search') {
      countLabel = __t(`${msgKey}.labels.result`, { withPlural: totalItems });
    }

    if (type === 'lists') {
      countLabel = __t(`${msgKey}.labels.creator`, { withPlural: totalItems });
    }

    return (
      <div>
        <span className="creator-tile-results-count__number">
          {totalItems}
        </span>
        {countLabel}
      </div>
    );
  };

  render(): React.ReactNode {
    return (
      <section className="creator-tile-results-count">
        {this.getResults()}
      </section>
    );
  }
}

export default CreatorTileResultsCount;
